import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { userPoolConfig } from '../helpers/globalValues';

// Required IDs for the Cognito User Pool in backend
// OBS: Remember to change values between production and development

export default new CognitoUserPool(userPoolConfig);
